import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { cancelRestaurantReservationV2 } from "../../../action/resReservationV2";


const CancelReservationPopUpV2 = (props) => {

    const { t } = props

    const [loading, setLoading] = useState(false);
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
    let widgetSesstionId = localStorage.getItem("resReservationV2SessionToken");

    const handleDeleteReservation = async () => {
        setLoading(true);
        let deletedSuccessfully = true;

        const payload = {
            reservationId: props.cancelReservationId,
        };

        try {
            const res = await cancelRestaurantReservationV2(payload);

            if (res.status !== 200) {
                deletedSuccessfully = false;

                props.sendAnalytics(
                    props.guestDetail,
                    props.currentWidgets.widgetType,
                    "DELETE RESERVATION - ERROR",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "deleteReservationID": props.cancelReservationId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg) },
                    0,
                    props.guestIsLoggedIn
                );
            } else {
                props.sendAnalytics(
                    props.guestDetail,
                    props.currentWidgets.widgetType,
                    "DELETE RESERVATION - Success",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "deleteReservationID": props.cancelReservationId },
                    0,
                    props.guestIsLoggedIn
                );
            }
        } catch (err) {
            console.log(err);
            deletedSuccessfully = false;
        }

        setLoading(false);
        props.handleDeleteReservation(deletedSuccessfully);
    };


    React.useEffect(() => {
        console.log(props.cancelReservationId)
    }, [])

    return (
        <>
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title">
                                    <h2 style={{ color: "#000 !important" }}>{t('resReservationV2.cancel_reser.heading1')}</h2>
                                    <p>{t('resReservationV2.cancel_reser.subHeading')}</p>
                                </div>
                                <div class="overlay-header-icon">
                                    <i class="fas fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                        <div class="overlay-controls">
                            {loading ? <button disabled class="button"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('resReservationV2.cancelling')}</button> : <button onClick={() => handleDeleteReservation()} class="button">{t('resReservationV2.cancel')}</button>}
                            <button onClick={() => props.close()} class="button secondary">{t('resReservationV2.close')}</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(CancelReservationPopUpV2));